/**
 * @author Alex
 */
export enum EnterpriseTypeEnum {
  ENTERPRISE = 'ENT',
  RETAILER = 'RET',
}
